module.exports = __webpack_public_path__ + "static/apple-icon-152x152-54f09e8f151dc48461d08343409da32e.png";